import httpClient, { isHttpError } from '../httpClient';

export async function getFluxoProaq(id: string) {
  try {
    const response = await httpClient.get(`/api/fluxoproaq/${id}`);

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getFasesByFluxoProaq(id: string) {
  try {
    const response = await httpClient.get(`/api/fluxoproaq/${id}/fases`);

    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    if (isHttpError(error) && error.response?.status === 404) {
      console.log('Nenhuma fase encontrada. Retornando lista vazia.');
      return [];
    }
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getProaqsByFluxoProaq(id: string) {
  try {
    const response = await httpClient.get(`/api/fluxoproaq/${id}/proaqs`);

    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    if (isHttpError(error) && error.response?.status === 404) {
      console.log('Nenhum proaq associado encontrado. Retornando lista vazia.');
      return [];
    }
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getFluxoProaqByModalidadeCoordenacao(
  modalidade: number,
  coordenacao: number,
) {
  try {
    const response = await httpClient.get(
      `/api/fluxoproaq/${coordenacao}/${modalidade}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}

export async function getAllFluxoProaq() {
  try {
    const response = await httpClient.get(`/api/fluxoproaq`);
    return Array.isArray(response.data.registros)
      ? response.data.registros
      : [];
  } catch (error) {
    throw new Error('Erro ao obter lista de registros: ' + error);
  }
}

export async function getFluxoProaqByModalidadeCoordenacaoBool(
  modalidade: number,
  coordenacao: number,
) {
  try {
    const response = await httpClient.get(
      `/api/fluxoproaq/verifica-modelo-ativo/${modalidade}/${coordenacao}`,
    );

    return response.data;
  } catch (error) {
    throw new Error('Erro ao obter registro: ' + error);
  }
}
